import {Button, Checkbox, Col, Input, Row} from 'antd';
import Form, {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import * as React from 'react';
import {WithTranslation} from 'react-i18next';
import ProjectTemplateEditor from '../../../../components/project-template-editor';
import {nameof} from '../../../../core/utils/object';
import {NewTaskTemplateItem} from '../../../../stores/templates-store';

let FormItem = Form.Item;


interface ClassFormBodyProps extends WithTranslation {
    companyId: string,
    item: NewTaskTemplateItem | undefined,
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    resetfields: any,
    onAddTask:any,
    disabled?: boolean,
    companyAllowCir: boolean,
    companyAllowCii: boolean,
}

class TaskTemplateFormBody extends React.Component<ClassFormBodyProps> {
    render() {
        const { t, getFieldDecorator, resetfields, onAddTask } = this.props;

        var item = this.props.item || {} as NewTaskTemplateItem;
        return (
            <>
                <Row gutter={24}>
                    <Col span={24}>
                        <FormItem label={t("Task Template Name")}>
                            {getFieldDecorator(nameof<NewTaskTemplateItem>('title'), {
                                initialValue: item.title,
                                rules: [{ required: true, message: t('Title required') },
                                    { whitespace: true, message: t('Title required') }],
                            })(
                                <Input maxLength={255} disabled={this.props.disabled} placeholder={t("Task template name")} type="text" />
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <FormItem label={t("Reference")}>
                            {getFieldDecorator(nameof<NewTaskTemplateItem>('reference'), {
                                initialValue: item.reference || '',
                            })(
                                <Input maxLength={255} disabled={this.props.disabled} placeholder={t("Task template reference")} type="text" />
                            )}
                        </FormItem>
                    </Col>
                </Row>

                <Row gutter={24}>
                    
                </Row>
                <Row gutter={24} justify="space-between" type="flex">
                    <Col span={11}>
                        <FormItem label={t("Project Templates1")}>
                            {getFieldDecorator(nameof<NewTaskTemplateItem>('projectTemplates'), {
                                initialValue: item.projectTemplates || [],
                            })(
                                <ProjectTemplateEditor disabled={this.props.disabled} companyId={this.props.companyId} />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={3}>
                        <FormItem label={t("Sticky")}>
                            {getFieldDecorator(nameof<NewTaskTemplateItem>('sticky'), {
                                initialValue: item.sticky || false, valuePropName: 'checked'
                            })(
                                <Checkbox disabled={this.props.disabled}/>
                            )}
                        </FormItem>
                    </Col>
                    <Col span={5}>
                        <FormItem label={t("CII Eligibility")}>
                            {getFieldDecorator(nameof<NewTaskTemplateItem>('ciiEligibility'), {
                                initialValue: item.ciiEligibility || false, valuePropName: 'checked'
                            })(
                                <Checkbox disabled={this.props.disabled || !this.props.companyAllowCii} />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={5}>
                        <FormItem label={t("CIR Eligibility")}>
                            {getFieldDecorator(nameof<NewTaskTemplateItem>('cirEligibility'), {
                                initialValue: item.cirEligibility || false, valuePropName: 'checked'
                            })(
                                <Checkbox disabled={this.props.disabled || !this.props.companyAllowCir}/>
                            )}
                        </FormItem>
                    </Col>
                    
                </Row>
                <Row justify="end" type="flex">
                    <Col  >
                        <Button disabled={this.props.disabled} type="dashed" style={{ marginTop: 30, marginBottom:15 }} icon="plus"
                            onClick={() => {
                                this.props.onAddTask(this.props.resetfields)

                            }}>
                            {t("Add")}
                        </Button>
                        
                    </Col>
                </Row>
                
            </>
        )
    }
}


// Wire up the React component to the Redux store
export default TaskTemplateFormBody;
